import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gallery-amazon-container" }
const _hoisted_2 = { class: "main-image-wrap" }
const _hoisted_3 = ["src", "alt"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["product-gallery-col", { 'full-width-gallery': !_ctx.description || _ctx.description.trim() === '' }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: _ctx.activeImage,
          alt: _ctx.productName,
          class: "product-main-img"
        }, null, 8 /* PROPS */, _hoisted_3)
      ])
    ])
  ], 2 /* CLASS */))
}